<template>
  <div :class="divClasses">
    <a
      class="calculator__calibre faq__main-title +display-block +heading-zeta"
      :class="[linkClasses, isOpen ? '--expanded' : '']"
      v-on:click.prevent="toggle($event)"
    >
      {{ isOpen ? openLinkText : closedLinkText }}
      <span class="faq__icon" :class="[isOpen ? '--expanded' : '']">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="18px"
          height="18px"
          viewBox="-1 -2 8 8"
          version="1.1"
        >
          <g stroke="none" stroke-width="1" fill="" fill-rule="evenodd">
            <g transform="translate(-134.000000, -43.000000)" fill="">
              <polygon
                points="134.707107 43 134 43.6965437 137.353553 47 140.707107 43.6965437 140 43 137.358734 45.6018093"
              ></polygon>
            </g>
          </g>
        </svg>
      </span>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    callback: {
      // function to call when the link is clicked
      type: Function || undefined
    },
    divClasses: {
      // css classes to add to the link's parent div
      type: String,
      default: ''
    },
    linkClasses: {
      // css classes to add to the link
      type: String,
      default: ''
    },
    targetClass: {
      // class of its target
      type: String,
      default: 'extraPaymentsDiv'
    },
    closedLinkText: {
      // text of link in closed state
      type: String,
      default: 'Open'
    },
    openLinkText: {
      // text of link in open state
      type: String,
      default: 'close'
    }
  },
  computed: {
    isOpen() {
      if (this.$store) {
        return this.$store.state[this.targetClass + 'Open']
      } else {
        return this.$parent[this.targetClass + 'Open']
      }
    }
  },
  methods: {
    toggle(event) {
      if (typeof this.callback === 'function') {
        this.callback(event)
      }
    }
  }
}
</script>
